import { memo } from 'react';

import { IconSvg, Text } from '@/lib/v2/components';

import { TwoFactorAuthentication } from '@/src/modules/AuthModule/images/icons/TwoFactorAuthentication';
interface HeaderProps {
  title: string;
  description: string;
}

const Header = ({ title, description }: HeaderProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-4">
      <IconSvg className="!h-20 !w-20" svgComponent={<TwoFactorAuthentication />} />
      <div className="flex flex-col items-center gap-1">
        <Text fontWeight="medium" variant="headline">
          {title}
        </Text>
        <Text alignment="center" variant="text">
          {description}
        </Text>
      </div>
    </div>
  );
};

export default memo(Header);
